export type EmailBodyPart = { text: string; href?: string };

export function emailBodyLinks(body: string): EmailBodyPart[] {
    const text = body
        .replace(/\\([\\<>.:])/g, "$1")
        .replace(/<\[([^\]\r\n]+)\]\(((?:https?:\/\/|mailto:|tel:)[^\s)]+)\)>/gi, "[$1]($2)")
        .replace(/\[cid:[^\]\r\n]+\]/gi, "")
        .replace(/([\w.+-]+@[\w.-]+\.[a-z]{2,})\s*<mailto:\1>/gi, "<mailto:$1>")
        .replace(/(\+?[\d ()-]+)<tel:([^>]+)>/g, (_match, label, phone) =>
            label.trim().replace(/[^\d+]/g, "") === phone.replace(/[^\d+]/g, "") ? `<tel:${phone}>` : `${label}<tel:${phone}>`);
    const pattern = /\[([^\]\r\n]+)\]\(((?:https?:\/\/|mailto:|tel:)[^\s)]+)\)|<((?:https?:\/\/|mailto:|tel:)[^<>\s]+)>|(?:https?:\/\/|www\.)[^\s<>]+|[\w.+-]+@[\w.-]+\.[a-z]{2,}/gi;
    const parts: EmailBodyPart[] = [];
    let cursor = 0;
    let match: RegExpExecArray | null;
    while ((match = pattern.exec(text)) !== null) {
        if (match.index > cursor) parts.push({ text: text.slice(cursor, match.index) });
        const raw = match[2] || match[3] || match[0];
        const url = match[2] || match[3] ? raw : raw.replace(/[.,;:!?]+$/, "");
        const href = /^www\./i.test(url) ? `https://${url}` : /^[\w.+-]+@/.test(url) ? `mailto:${url}` : url;
        parts.push({ text: match[1] || url.replace(/^(mailto:|tel:)/i, ""), href });
        if (url.length < raw.length) parts.push({ text: raw.slice(url.length) });
        cursor = pattern.lastIndex;
    }
    if (cursor < text.length) parts.push({ text: text.slice(cursor) });
    return parts;
}